import { RadioClassKey } from '@material-ui/core/Radio';
import { Theme } from '@material-ui/core/styles';

const MuiRadio = (theme: Theme): Partial<Record<RadioClassKey, unknown>> => ({
    /* Styles applied to the root element. */
    root: {
        color: theme.palette.grey[400],
        '&.Mui-checked svg:first-of-type': {
            color: theme.palette.grey[400],
        },
    },
    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
        '&$checked': {
            color: theme.palette.primary.main,
        },
        '&$disabled': {
            color: theme.palette.action.disabledBackground,
        },
    },
    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
        '&$checked': {
            color: theme.palette.secondary.main,
        },
        '&$disabled': {
            color: theme.palette.action.disabledBackground,
        },
    },
});

export default MuiRadio;
